<template>

  <div class="datatable-toolbar quiz-toolbar mb-3">
    <div class="quiz-search">
      <label class="sr-only" for="quiz-search">Search quizzes</label>
      <input id="quiz-search" type="search" class="form-control" placeholder="Search quizzes" v-model="dataFilter.searchText" @keyup.enter="doFind">
      <button class="btn btn-outline-primary" type="button" @click="doFind">Search</button>
      <button v-if="dataFilter.searchText" class="btn btn-link text-secondary clear-search" type="button" @click="clearSearch">Clear</button>
    </div>
    <RouterLink to="/quiz/add" class="btn btn-primary add-quiz-button"><i class="pi pi-plus mr-2" aria-hidden="true"></i>Add quiz</RouterLink>

    <ConfirmDialog></ConfirmDialog>

    <Dialog v-model:visible="showWinnerDialog" modal header="Quiz Winners" :style="{ width: '50vw' }">
        <QuizWinnerList :quizId="selectedQuiz.id"></QuizWinnerList>
    </Dialog>

  </div>


  <div class="row table-container">
    <table class="table table-striped">

      <thead>
      <tr>
        <th scope="col">No</th>
        <th scope="col">Title</th>
        <th scope="col">Description</th>
        <th scope="col">Duration (seconds)</th>
        <th scope="col">Total Questions</th>
        <th scope="col">Total Participants</th>
        <th scope="col">Status</th>
        <th scope="col">Stared At</th>
        <th scope="col">Actions</th>
      </tr>
      </thead>

      <tbody>

      <tr v-if="dataList.length === 0">
        <td colspan="9" class="text-center table-message"><strong>No quizzes yet.</strong><span>Create a quiz when you are ready to select questions and invite participants.</span></td>
      </tr>

      <tr v-for="(data, index) in dataList" :key="data">
        <td class="order-number">{{ index + 1 }}</td>
        <td class="text-left">{{ data.title }}</td>
        <td class="text-left">{{ data.description }}</td>
        <td class="text-center">{{ data.duration }}</td>
        <td class="text-center">{{ data.totalQuestion }}</td>
        <td class="text-center">{{ data.totalParticipant }}</td>
        <td class="text-center">{{ data.statusLabel }}</td>
        <td class="text-center">{{ fmtDate(data.startedAt) }}</td>
        <td class="actions">
          <button type="button" class="btn btn-outline-secondary" v-tooltip="'Start quiz'" @click="onStart(data)"  v-if="data.status === 0 || data.status === 1">
            <i class="pi pi-caret-right"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary" v-tooltip="'End quiz'" @click="onEnd(data)" v-if="data.status === 2">
            <i class="pi pi-power-off"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary" v-tooltip="'Edit'" @click="onEdit(data)" v-if="data.status === 1 || data.status === 0">
            <i class="pi pi-pencil" title="Edit"></i>
          </button>

          <button type="button" class="btn btn-outline-secondary" v-tooltip="'Show winners'" @click="onShowQuizWinners(data)" v-if="data.status === 3">
            <i class="pi pi-gift"></i>
          </button>
          
          <button type="button" class="btn btn-outline-secondary" v-tooltip="'Remove'" @click="onRemove(data)">
            <i class="pi pi-trash" title="Remove"></i>
          </button>

        </td>
      </tr>
      </tbody>

    </table>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import apiService from "@/services/ApiService";
import moment from "moment";
import Dialog from 'primevue/dialog';
import ConfirmDialog from 'primevue/confirmdialog';
import QuizWinnerList from '@/components/quiz/QuizWinnerList.vue';

export default defineComponent({
  name: "QuizList",
  components: {
    Dialog, ConfirmDialog, QuizWinnerList
  },
  data() {
    return {
            dataList: [],
      showRemoveConfirmDialog: false,
      showWinnerDialog: false,
      dataFilter: {
        searchText: ''
      }
    }
  },
  methods: {
    onEdit(data) {
      this.$router.push(`/quiz/edit/${data.id}`);
    },
    onRemove(data) {
      this.$confirm.require({
        message: 'Are you sure you want to remove ?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.doRemove(data.id);
        }
      });
    },
    onStart(data) {
      this.$confirm.require({
        message: 'Are you sure you want to start this quiz ?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.doStart(data.id);
        }
      });
    },
    onEnd(data) {
      this.$confirm.require({
        message: 'Are you sure you want to end this quiz ?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.doEnd(data.id);
        }
      });
    },
    doFind() {
      const params = {
        SearchText: this.dataFilter.searchText
      };
      apiService.get('/quiz', {params: params})
          .then(response => {
            this.dataList = response.data;
          })
          .catch(error => {
            console.log(error);

            this.$toast.add({
              severity: 'error',
              summary: 'Failed to get quiz',
              detail: error.response.data.Message,
              life: 5000
            });
          });
    },
    clearSearch() { this.dataFilter.searchText = ''; this.doFind(); },
    doRemove(id) {
      apiService.delete(`/quiz/${id}`)
          .then(() => {
            this.doFind();

            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Quiz has been remove',
              life: 5000
            });
          })
          .catch(error => {

            console.log(error);

            this.$toast.add({
              severity: 'error',
              summary: 'Failed to remove quiz',
              detail: error.response.data.Message,
              life: 5000
            });
          });
    },
    doStart(id) {
      apiService.post(`/quiz/${id}/start`)
          .then(() => {
            this.doFind();

            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Quiz has been started',
              life: 5000
            });
          })
          .catch(error => {

            console.log(error);

            this.$toast.add({
              severity: 'error',
              summary: 'Failed to start quiz',
              detail: error.response.data.Message,
              life: 5000
            });
          });
    },
    doEnd(id) {
      apiService.post(`/quiz/${id}/end`)
          .then(() => {
            this.doFind();

            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Quiz has been ended',
              life: 5000
            });
          })
          .catch(error => {

            console.log(error);

            this.$toast.add({
              severity: 'error',
              summary: 'Failed to end quiz',
              detail: error.response.data.Message,
              life: 5000
            });
          });
    },
    onShowQuizWinners(data) {
      this.selectedQuiz = data;
      this.showWinnerDialog = true;
    },
    fmtDate(date) {
      if(date === null || date === undefined || date === ''){
        return '';
      }
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    }
  },
  mounted() {
    this.dataList = [];
    this.doFind();
  }
})
</script>

<style scoped>
.quiz-toolbar{align-items:center;display:flex;gap:.75rem;justify-content:space-between}.quiz-search{align-items:center;display:flex;flex:1;flex-wrap:wrap;gap:.5rem}.quiz-search .form-control{max-width:19rem}.clear-search{font-size:.875rem;padding-left:.25rem;padding-right:.25rem}.add-quiz-button{white-space:nowrap}.table-message{color:#6c757d;padding:2.5rem 1rem!important}.table-message strong,.table-message span{display:block}.table-message strong{color:#343a40;margin-bottom:.35rem}@media(max-width:767.98px){.quiz-toolbar{align-items:stretch;flex-direction:column}.quiz-search .form-control{max-width:none;width:100%}.add-quiz-button{align-self:flex-start}}

</style>
